import { render, staticRenderFns } from "./mobile-facets.vue?vue&type=template&id=64436fed&scoped=true"
import script from "./mobile-facets.vue?vue&type=script&lang=js"
export * from "./mobile-facets.vue?vue&type=script&lang=js"
import style0 from "./mobile-facets.vue?vue&type=style&index=0&id=64436fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64436fed",
  null
  
)

export default component.exports